import React from 'react';
import '../App.css';
import ReactImageMagnify from 'react-image-magnify';


class Magnifier extends React.Component {




    render() {

        const imageProps = {
            smallImage: {
                alt: this.props.alt,
                isFluidWidth: false,
                src: this.props.src,
                width: 320,
                height: 320
            },
            largeImage: {
                src: this.props.src,
                width: 500,
                height:500,
            },
            imageStyle:{maxWidth:'none'},
            enlargedImageStyle:{maxWidth:'none'},
            shouldUsePositiveSpaceLens: true,
            enlargedImagePortalId: 'portal',
            enlargedImageContainerStyle: { border: '4px solid #888' , background:'white' , zIndex: "2"},
            enlargedImageContainerDimensions: {
                width: '120%',
                height: '120%'
                
            },
            lensStyle: {
                border: '1px solid #888',
                background: 'rgba(255, 255, 255, 0.5)',
                cursor: 'default',
                opacity: '0.1',
                width: '100px',
                height: '100px'

            }
        };
        return (
            <div class="img-cont" >
                <ReactImageMagnify {...imageProps} />
            </div>
        )
    }
}



export default Magnifier;